import { useNavigate } from 'react-router-dom';
import { Header } from '@/components/Header/Header';
import { BottomBar } from '@/components/BottomBar/BottomBar';

/**
 * Экран 2.10.2 «Спасибо!» — Block 10 Phase 4 Step 3 / Phase 5 Step 2
 * (PRD §14 confirmation screen).
 *
 * Success-экран после успешного submit формы 2.10.1. Primary CTA — кнопка
 * «Готово», ведёт на «/». Секция оборачивается в `<main>`, BottomBar (variant
 * default — 3 кнопки) рендерится sibling'ом ниже main per CLAUDE.md §16.4
 * «sticky BottomBar на всех экранах кроме Главной».
 *
 * **Naming nuance:** primary CTA — «Готово», а не «На главную», потому что
 * BottomBar тоже содержит кнопку «На главную» (default variant). Если бы main
 * button называлась «На главную», testing-library `getByRole('button', { name:
 * 'На главную' })` нашёл бы две — Phase 5 Step 2 разрешает duplicate-match
 * через rename. Behaviorally эквивалентно: «Готово» onClick ведёт туда же
 * (`navigate('/')`).
 *
 * BottomBar buttons на 2.10.2:
 *   - «Назад» (P-036) → `navigate(-1)` или `/` если истории нет.
 *   - «На главную» → `navigate('/')`.
 *   - «Что улучшить» → default-flow `navigate('/feedback', { state: { blockId:
 *     'block-10', screenId: '2.10.2' } })` через `pathInference`. Повторное
 *     открытие пустой формы — корректный flow если пользователь хочет ещё
 *     один feedback.
 *
 * Сюда ведёт `navigate('/feedback/sent')` из `FeedbackForm.handleSubmit`
 * (после успешного `apiClient.feedback.create` + `clearDraft`).
 */
export function FeedbackConfirm() {
  const navigate = useNavigate();

  return (
    <>
      <main className="min-h-screen flex flex-col bg-canvas">
        <Header title="Что улучшить?" />

        <section className="flex-1 p-6 overflow-y-auto flex flex-col gap-5 items-center justify-center">
          <h1 className="font-display text-h1 text-ink m-0 text-center">Спасибо!</h1>
          <p className="text-ink text-[18px] text-center max-w-[320px]">
            Ваше мнение для нас важно.
          </p>
          <button
            type="button"
            onClick={() => navigate('/')}
            aria-label="Готово"
            className={[
              'w-full min-h-tap rounded-lg bg-cta border-b-2 border-cta-shadow text-ink',
              'font-bold text-[18px] py-3',
              'focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none active:opacity-90',
            ].join(' ')}
          >
            Готово
          </button>
        </section>
      </main>
      <BottomBar variant="default" />
    </>
  );
}
